<template>
	<div v-if="mode === 'default'">
		<coupon></coupon>
	</div>
	<div v-else-if="mode === 'dropdown'">
		<div class="dropdown coupon-toggle-wrapper basketDropdown">
			<div class="btn dropdown-toggle" type="button" data-toggle="dropdown">
				{{ $translate("Eros::Template.couponDropdownLabel") }}
			</div>
			<div class="cmp dropdown-menu">
				<coupon></coupon>
			</div>
			<div class="clearfix"></div>
		</div>
	</div>
	<div v-else-if="mode === 'link'">
		<span v-if="!isVisible" class="mb-0">
			<a class="px-0 pt-0 btn btn-block text-right text-muted" @click="showCouponInput()">
				<u class="small">{{ $translate("Eros::Template.couponLinkLabel") }}</u>
			</a>
		</span>
		<coupon v-else></coupon>
	</div>
</template>

<script>
import Coupon from "./Coupon.vue";

export default {
    name: "coupon-toggle",

	components: {
		Coupon
	},

	props: {
		mode: {
			type: String,
			default: "default"
		}
	},

	data() {
		return {
			isVisible: false
		};
	},

	methods: {
		showCouponInput() {
			this.isVisible = true;

			if (!!dataLayer) {
				dataLayer.push({'event': 'funnel_event', 'action': 'OPEN_COUPON_BASKET'});
			}
		}
	}
};
</script>